import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import UpdateTicketingProfileMutation from '../../../../../mutations/ticketing/auth/useUpdateTicketingProfileMutation';

export function useUpdateProfile() {
	const [savingSignature, setSavingSignature] = useState(false);
	const [savingReplyToEmail, setSavingReplyToEmail] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function saveSignature(emailSignature: string | null): Promise<void> {
		setError(null);
		setSavingSignature(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				UpdateTicketingProfileMutation,
				{emailSignature},
				() => {
					setSavingSignature(false);
					resolve();
				},
				err => {
					setSavingSignature(false);
					setError(err instanceof Error ? err.message : String(err));
					reject(err);
				}
			);
		});
	}

	function saveReplyToEmail(replyToEmail: string | null): Promise<void> {
		setError(null);
		setSavingReplyToEmail(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				UpdateTicketingProfileMutation,
				{replyToEmail},
				() => {
					setSavingReplyToEmail(false);
					resolve();
				},
				err => {
					setSavingReplyToEmail(false);
					setError(err instanceof Error ? err.message : String(err));
					reject(err);
				}
			);
		});
	}

	return {saveSignature, savingSignature, saveReplyToEmail, savingReplyToEmail, error, setError};
}
